import React from 'react';
import { Stack, Card, CardContent, Container, Typography, Breadcrumbs,Link, Button, Grid, InputAdornment } from '@mui/material';
import Page from '../../components/Page';
import { Link as RouterLink } from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';
import HTTPManager from '../../utils/httpRequestManager';
import TableContent from '../../components/table/tableView'; 
import Loader from '../../components/Loader';
import FTextField from '../../components/formComponents/components/textField';
import FCurrency from '../../components/formComponents/components/currency';

export default class PlanManager extends React.Component{
    httpManager = new HTTPManager();
    constructor(props){
        super(props);
        this.state={
            isLoading:true,
            planslist:[],
            addForm:false,
            planData:{
                planName:'',
                planFee:'', 
                planTagLine:'',
                planFeatures:[
                    {
                        feature:''
                    }
                ]
            },
            columns: [
                {
                    field: 'planName',
                    headerName: 'Plan Name', 
                    flex:1,
                    renderCell: (params) => <div> {params.row.planName} </div>
                },
                {
                    field: 'planFee',
                    headerName: 'planFee', 
                    flex:1,
                    editable:false,
                    sortable:false,
                    renderCell: (params) => <div> ${Number(params.row.planFee.split(",").join("")).toFixed(2)} </div>
                  }, 
                  {
                    field: 'action',
                    headerName: '',
                    maxWidth: 200,
                    flex:1,
                    editable:false,
                    sortable:false,
                    renderCell: (params) => { 
                        return (
                            <div style={{ textTransform: 'capitalize', display:'flex', flexDirection:'row' }}> 
                                <Button variant="outlined" 
                                        size="small" 
                                        onClick={()=>this.editRecord(params.row)} 
                                        label="View">Edit</Button>
                                {params.row.planStatus==='1' && <Button variant="contained" 
                                        size="small" 
                                        onClick={()=>this.updateRecord(params.row, '0')} 
                                        label="View">Deactivate</Button>}
                                {params.row.planStatus==='0' && <Button variant="contained" 
                                    size="small" 
                                    onClick={()=>this.updateRecord(params.row, '1')} 
                                    label="View">Activate</Button> }
                                </div>
                            )
                        }
                  },

            ]
        }

        this.editRecord = this.editRecord.bind(this)
        this.updateRecord = this.updateRecord.bind(this)
    }

    editRecord(row){
        this.setState({planData: row, addForm: true})
    }

    updateRecord(row, status){ 
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.postRequest('/plans/updatePlan', {id: row.id, planStatus: status}).then(r=>{
                this.reloadData(r.message)
            })
        })
    }

    savePlan(){
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.postRequest('/plans/savePlan', this.state.planData).then(r=>{
                this.setState({planData:{
                    planName:'',
                    planFee:'', 
                    planTagLine:'',
                    planFeatures:[
                        {
                            feature:''
                        }
                    ]
                }})
                this.reloadData(r.message)
            })
        })
    }

    componentDidMount(){
        this.reloadData();
    }

    reloadData(msg=''){

        if(msg !== ''){
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

        this.httpManager.getRequest(`/plans/getPlans`).then(r=>{
            this.setState({planslist: r.data, isLoading: false})
        })
    }

    render(){
        return  <Page title="Plans | Astro POS">
            <Container maxWidth="xl">
                <ToastContainer 
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                    /> 
                {this.state.isLoading && <Loader/>}
                <Stack direction="column" alignItems="left" mb={5}>
                    <Typography variant="h4" gutterBottom> Plans Management </Typography>
                    <Breadcrumbs separator=">" aria-label="breadcrumb">
                        <Link component={RouterLink} underline="hover" color="inherit" to="/dashboard/app">
                            Dashboard
                        </Link> 
                        <Typography color="text.primary">Plans</Typography>
                    </Breadcrumbs>
                </Stack>
                {!this.state.addForm && <Card>
                    <CardContent>
                        <Stack direction={"row"} justifyContent={"flex-end"} style={{margin:10}}>
                            <Button variant={'contained'} onClick={()=>{
                                this.setState({planData:{
                                    planName:'',
                                    planFee:'', 
                                    planTagLine:'',
                                    planFeatures:[
                                        {
                                            feature:''
                                        }
                                    ]
                                }},()=>{
                                    this.setState({addForm: true})
                                }) 
                            }}>+ Add Plan</Button>
                        </Stack>
                        <TableContent data={this.state.planslist} columns={this.state.columns} />
                    </CardContent>
                </Card>}
                {this.state.addForm && <Card>
                    <CardContent>   
                        <Grid container spacing={3}  alignItems="center"  justifyContent="center" className='formGrid' >
                            <Grid item xs={6}>
                                <FTextField label={"Plan Name"} autoFocus={true} fullWidth={true}  type="text" format="text" value={this.state.planData.planName} onChange={(e)=>{
                                var plandata = Object.assign({}, this.state.planData)
                                plandata.planName = e.target.value
                                this.setState({planData: plandata})
                                }} maxLength={50} />
                            </Grid>
                            <Grid item xs={6}>
                                <FCurrency label={"Plan Fee"} autoFocus={false} fullWidth={true}  type="text"  value={this.state.planData.planFee} onChange={(e)=>{
                                    console.log(e)
                                    var plandata = Object.assign({}, this.state.planData)
                                    plandata.planFee = e.target.value
                                    this.setState({planData: plandata})
                                }} maxLength={50} InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}/>
                            </Grid>
                            <Grid item xs={6}>
                                <FTextField label={"Tag Line"} autoFocus={true} fullWidth={true}  type="text" format="text" value={this.state.planData.planTagLine} onChange={(e)=>{
                                    var plandata = Object.assign({}, this.state.planData)
                                    plandata.planTagLine = e.target.value
                                    this.setState({planData: plandata})
                                }} maxLength={50} />
                            </Grid>
                            <Grid item xs={6}></Grid>
                        </Grid> 

                        <Grid container spacing={3}  alignItems="center"  justifyContent="center" className='formGrid' >
                            {this.state.planData.planFeatures.map((f, i)=>{
                                return <Grid container style={{margin:i===0 ? '1rem 0 0 0':'6px 0 0 0'}} spacing={3} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                            <Grid item xs={9}> 
                                                <FTextField label={"Feature"} autoFocus={true} fullWidth={true}  type="text" format="text" value={this.state.planData.planFeatures[i].feature} onChange={(e)=>{
                                                    var plandata = Object.assign({}, this.state.planData)
                                                    plandata.planFeatures[i].feature = e.target.value
                                                    this.setState({planData: plandata})
                                                }} maxLength={50} />
                                            </Grid>
                                            <Grid item xs={3}>
                                                {i === 0 && <Button variant='contained' onClick={()=>{
                                                    var plandata = Object.assign({}, this.state.planData);
                                                    plandata.planFeatures.push({
                                                        feature:''
                                                    })
                                                    this.setState({planData: plandata})
                                                }}>+</Button>}
                                                {i > 0 && <Button variant='contained' onClick={()=>{
                                                    var plandata = Object.assign({}, this.state.planData);
                                                    plandata.planFeatures.splice(i,1)
                                                    this.setState({planData: plandata})
                                                }}>-</Button>}
                                            </Grid>
                                        </Grid>
                            })}
                        </Grid>

                        <Stack direction={"row"} alignItems={"center"} style={{margin:10}} gap={'10px'} justifyContent={"center"}>
                            <Button variant={'outlined'} onClick={()=>{
                                this.setState({addForm: false})
                            }}>Cancel</Button> 
                            <Button variant={'contained'} onClick={()=>{
                                this.savePlan()
                            }}>Save</Button> 
                        </Stack>

                    </CardContent>    
                </Card>}
            </Container>
        </Page>
    }
}